import { render, staticRenderFns } from "./TreemapWidget.vue?vue&type=template&id=3a59b115&scoped=true"
import script from "./TreemapWidget.vue?vue&type=script&lang=js"
export * from "./TreemapWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59b115",
  null
  
)

export default component.exports